module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-combo"
  }, [_c('div', {
    staticClass: "floating-box"
  }, [_c('a', {
    attrs: {
      "href": "/donate"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.welcometopalestine.com/wp-content/uploads/2017/05/Artboard-2.png",
      "alt": "Donate banner",
      "width": "640",
      "height": "100"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06bb5833"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/donate-banner.vue
// module id = 163
// module chunks = 4